import ServicesContactSection from "./ServicesContactSection";

const ServicesContactsSection = (props) => {
  return props.ContactData?.map((item, index) => {
    return <ServicesContactSection key={index} item={item} />;
  });
};
export default ServicesContactsSection;
